import { Drawer } from '@material-ui/core'
import { useAtom } from 'jotai'
import * as React from 'react'
import styled from 'styled-components'
import SearchResults from '../search/SearchResults'

import { Search, ChevronLeft } from '@geist-ui/react-icons'
import { rwMobileSearchAtom } from '../../atoms/Notifications'
import SearchInput from './input/SearchInput'

const SearchDrawer = (): JSX.Element => {
  const [open, setOpen] = useAtom(rwMobileSearchAtom)

  React.useEffect(() => {
    if (open) {
      console.log('FOCUSING!')
      const element = document.getElementById('mobile-search-bar')
      element?.focus()
    } else {
      const element = document.getElementById('mobile-search-bar')
      element?.blur()
    }
  }, [open])

  return (
    <Drawer
      aria-labelledby="notification-drawer"
      open={open}
      anchor="right"
      onClose={(): void => {
        setOpen(false)
      }}
      PaperProps={{
        style: {
          backgroundColor: '#101010',
          width: '100vw',
        },
      }}
      BackdropProps={{
        style: {
          backdropFilter: 'blur(2px)',
          backgroundColor: 'rgba(0,0,0,.1)',
        },
      }}
    >
      <OuterDiv>
        <TitleDiv>
          <ChevronLeft color="#fff" size={25} onClick={() => setOpen(false)} />
          <InnerDiv>
            <Search color="white" size={25} />
            {open && <SearchInput />}
          </InnerDiv>
        </TitleDiv>
        <SearchResults />
      </OuterDiv>
    </Drawer>
  )
}

export default SearchDrawer

const InnerDiv = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  background: linear-gradient(rgb(35, 35, 35), rgb(20, 20, 20));
  border-width: 1px;
  border-color: #333;
  border-style: solid;
  padding: 8px;
  cursor: text;
  width: calc(100% - 16px);
  border-radius: 10px;
  margin-left: 15px;
`

const OuterDiv = styled.div`
  /* width: calc(100% - 30px); */
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  /* margin: 30px 30px 30px 0; */
  padding: 15px;
  margin-top: 15px;
`

const TitleDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 15px;
  width: 100%;
`
